import { render, staticRenderFns } from "./AssignConfirmationModal.vue?vue&type=template&id=3449a9da&"
import script from "./AssignConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./AssignConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports